import React, {useContext, useEffect, useState} from "react";
import styles from "./flowSelection/FlowSelection.module.scss";
import ActivityItem from "./flowSelection/ActivityItem";
import { Container, Draggable } from 'react-smooth-dnd';
import Button from "../../../../Componnets/Button/Button";
import apiCaseAttributesColumnsData from "../../../../../services/api/apiCaseAttributesColumnsData";
import appContext from "../../../../../context/appContext";

const FlowSelection = ({ title, handleOnChangeFlow, selectedItems, handleAddNewFilter, themeColor }) => {

  const [activitiesData, setActivitiesData] = useState(null);
  const [activityItems, setActivityItems] = useState([]);

  useEffect(() => {
    if (selectedItems.data && selectedItems.data.length) {
      setActivityItems(selectedItems.data);
    }
  }, [selectedItems.data])

  useEffect(() => {
    if (!selectedItems || !selectedItems.data || !selectedItems.data.length) {
      setActivityItems([
        {
          is_active: true,
          seq: [
            {
              activity_name: null,
              type: "ENDSEQUENCE"
            }
          ]
        }
      ])
    }
  }, []);

  useEffect(() => {
    handleOnChangeFlow(activityItems);
  }, [activityItems])

  const addNode = (type, index) => {
    const newData = activityItems.slice(0); // copy
    newData[newData.length - 1].seq.splice(index + 1, 0, {
      activity_name: null,
      type: "ENDSEQUENCE"
    });
    newData[newData.length - 1].seq[index].type = type;
    setActivityItems(newData);
  }

  const removeNode = (index) => {
    const newData = activityItems.slice(0); // copy
    if(newData[newData.length - 1].seq.length && newData[newData.length - 1].seq.length > 1) {
      const items = newData[newData.length - 1].seq.splice(index, 1)[0];
      newData[newData.length - 1].seq[newData[newData.length - 1].seq.length - 1].type = "ENDSEQUENCE";
      setActivityItems(newData);
    }
  }

  const editNode = (typeOfFollow, index) => {
    const newData = activityItems.slice(0); // copy
    newData[newData.length - 1].seq[index].type = typeOfFollow;
    setActivityItems(newData);
  }

  const editActivityName = (activityName, index) => {
    const newData = activityItems.slice(0); // copy
    newData[newData.length - 1].seq[index].activity_name = activityName;
    setActivityItems(newData);
  }

  const onDrop = ({removedIndex, addedIndex}) => {
    if (removedIndex === null && addedIndex === null) return activityItems;

    const result = [...activityItems];

    let itemToAdd = null;
    if (removedIndex !== null) {
      itemToAdd = result[result.length - 1].seq.splice(removedIndex, 1)[0];
    }

    if (addedIndex !== null) {
      result[result.length - 1].seq.splice(addedIndex, 0, itemToAdd);
    }

    result[result.length - 1].seq = result[result.length - 1].seq.map((item, index) => {
      if (item.type === "ENDSEQUENCE") {
        return {...item, type: "directly_followed"}
      }
      return item
    });
    result[result.length - 1].seq[result[result.length - 1].seq.length - 1].type = "ENDSEQUENCE";
    setActivityItems(result);
  }

  const handleAddMore = () => {
    handleAddNewFilter("addMore", "flowSelection");
  }

  const context = useContext(appContext);
  const getActivitiesData = () => {
    apiCaseAttributesColumnsData.postSingle(context.handleUid().id, {field: 'ACTIVITY'}).then(res => {
      setActivitiesData(res.response.data.data.result);
    })
      .catch(err => {
        console.log(err);
      })
  }

  useEffect(() => {
    getActivitiesData();
  }, []);

  return (
    <div className={styles.FlowSelection}>
      <div className={styles.titleSection}>
        <div>
          { title }
        </div>
        <p>
          You can make an activity sequence here. Click on Done button to apply the filters.
        </p>
      </div>
      <div className={styles.mainContent}>
        <Container
          dragHandleSelector=".column-drag-handle"
          onDrop={e => onDrop(e)}
          dropPlaceholder={{
            animationDuration: 150,
            showOnTop: true,
            className: styles.cardsDropPreview
          }}
        >
          {
            activityItems &&
            activityItems[activityItems.length - 1] &&
            activityItems[activityItems.length - 1].seq &&
            activityItems[activityItems.length - 1].seq.length &&
            activityItems[activityItems.length - 1].seq.map((item, index) =>
              <Draggable key={index}>
                <ActivityItem
                  addNode={(type) => addNode(type, index)}
                  removeNode={() => removeNode(index)}
                  editNode={(typeOfFollow) => editNode(typeOfFollow, index)}
                  data={item}
                  availableEdit={activityItems[activityItems.length - 1].seq[index + 1]}
                  availableDelete={activityItems[activityItems.length - 1].seq.length > 1}
                  isFirstNode={index === 0}
                  activitiesData={activitiesData}
                  editActivityName={(activityName) => editActivityName(activityName, index)}
                  selectedActivities={item}
                  themeColor={themeColor}
                />
              </Draggable>
            )
          }
        </Container>
      </div>
      <div className={[styles.buttons, 'd-flex'].join(' ')}>
        <div className={'mr-2'}>
          <Button
            onClick={handleAddMore}
            title={'Add More'}
            color={context?.handleLayerList().find(item => item.selected)?.color}
            type={'outline'}
            size={'block'}
            height={"medium"}
          />
        </div>
      </div>
    </div>
  )
}

export default FlowSelection;